import React from 'react';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';

function SendMoneyBeneficiaryDetail({hideBackButton = false}) {
  const { state } = useLocation();
  const navigate = useNavigate();

  const beneficiary =state?.beneficiary;
  const currency_selected =state?.currency_type;
  const balance_amount = state?.balance;
  const SendMoneyFlowCurrency = state?.SendMoneyFlowCurrency;
  const Nav_node = Number(state?.Nav_node || 0);
  const workspaces = JSON.parse(sessionStorage.getItem('login_workspaces'));
  const account_type = workspaces?.[0]?.type;

  const displayCurrency =
    beneficiary?.currency ||
    beneficiary?.meta?.currency ||
    currency_selected ||
    SendMoneyFlowCurrency;

  if (!beneficiary) {
    return <div style={{ padding: 16, color: '#ef4444' }}>No beneficiary data provided.</div>;
  }

  const initials = (beneficiary.display_name || '?').charAt(0).toUpperCase();

  const cardContent = (
    <div style={{
      width: '640px',
      borderRadius: '16px',
      border: '1px solid #F2F2F2',
      background: '#FFFFFF',
      boxShadow: '0px 4px 16px rgba(0,0,0,0.06)',
      padding: '24px',
      display: 'flex',
      flexDirection: 'column',
      gap: '24px',
      boxSizing: 'border-box',
    }}>

      {/* Avatar + Name + Pay Button */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <div style={{
            width: 48, height: 48, borderRadius: '28px', background: '#203358',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 16, fontWeight: 500, color: '#FFFFFF', flexShrink: 0,
          }}>
            {initials}
          </div>
          <span style={{ fontSize: 16, fontWeight: 700, color: '#0B214E' }}>
            {beneficiary.display_name}
          </span>
        </div>

        {!hideBackButton && Nav_node !== 2 && account_type === 'business' && (
          <button
            onClick={() => navigate('/SendMoneyByBeneficiary', {
              state: {
                selectedBeneficiary: beneficiary.display_name,
                selectedbeneficiaryCode: beneficiary.code,
                selectedbeneficiaryBankAccoutNumber: beneficiary.bank_account_number,
                selectedbeneficiaryType: beneficiary.type,
                selectedbeneficiaryId: beneficiary.id,
                selectedbeneficiaryCountry: beneficiary.country,
                selectedbeneficiaryBankAccountId: beneficiary.bank_account_id,
                transferflowamount: '',
                currencyid: beneficiary.country_id,
                currency: currency_selected,
                accountType: beneficiary.bene_type,
                balanceAmount: balance_amount,
              },
            })}
            style={{
              width: '93px', height: '44px',
              display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
              paddingTop: '8px', paddingRight: '16px', paddingBottom: '8px', paddingLeft: '16px',
              background: '#D26521', color: '#FFFFFF',
              border: 'none', borderRadius: '8px',
              fontSize: '14px', fontWeight: 600,
              cursor: 'pointer', boxSizing: 'border-box',
              boxShadow: '0px 4px 24px rgba(157, 79, 26, 0.36)',
            }}
          >
            Pay
            <svg width="17" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M5 12h12M13 6l6 6-6 6" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        )}
      </div>

      {/* Inner Data Box */}
      <div style={{
        width: '100%', borderRadius: '12px',
        border: '1px solid #E6E5E5', background: '#FCFCFC',
        padding: '24px', display: 'flex', flexDirection: 'column',
        gap: '24px', boxSizing: 'border-box',
      }}>

        <div style={rowStyle}>
          <span style={labelStyle}>Name</span>
          <span style={valueStyle}>{beneficiary.display_name || beneficiary?.meta?.name || beneficiary?.meta?.bank_account_holder_name}</span>
        </div>

        <div style={rowStyle}>
          <span style={labelStyle}>Currency</span>
          <span style={valueStyle}>{displayCurrency}</span>
        </div>

        <div style={rowStyle}>
          <span style={labelStyle}>Account Number/IBAN</span>
          <span style={valueStyle}>{beneficiary.bank_account_number || beneficiary?.meta?.bank_account_number || beneficiary?.meta?.iban}</span>
        </div>

        <div style={rowStyle}>
          <span style={labelStyle}>Code</span>
          <span style={valueStyle}>
            {beneficiary?.code ?? beneficiary?.meta?.bic_swift ?? beneficiary?.meta?.aba_number ??
             beneficiary?.meta?.ifsc_code ?? beneficiary?.meta?.sort_code ?? beneficiary?.meta?.branch_code ??
             beneficiary?.meta?.bsb_number ?? beneficiary?.meta?.routing_code_value_1}
          </span>
        </div>

        {(beneficiary?.meta?.payment_type || beneficiary?.payment_type) && (
          <div style={rowStyle}>
            <span style={labelStyle}>Payment Type</span>
            <span style={valueStyle}>{beneficiary?.meta?.payment_type || beneficiary?.payment_type}</span>
          </div>
        )}

        {beneficiary?.meta?.beneficiary_country && (
          <div style={rowStyle}>
            <span style={labelStyle}>City</span>
            <span style={valueStyle}>{beneficiary?.meta?.beneficiary_city || '-'}</span>
          </div>
        )}

        {(beneficiary?.country || beneficiary?.meta?.beneficiary_country) && (
          <div style={rowStyle}>
            <span style={labelStyle}>Address</span>
            <span style={valueStyle}>{beneficiary?.address || beneficiary?.country || beneficiary?.meta?.beneficiary_country || '-'}</span>
          </div>
        )}

        {(beneficiary?.meta?.beneficiary_postcode || beneficiary?.beneficiary_postcode) && (
          <div style={rowStyle}>
            <span style={labelStyle}>Post Code</span>
            <span style={valueStyle}>{beneficiary?.meta?.beneficiary_postcode || beneficiary?.beneficiary_postcode}</span>
          </div>
        )}

        <div style={rowStyle}>
          <span style={labelStyle}>Account Type</span>
          <span style={valueStyle}>
            {beneficiary.type === 'Sort Code'
              ? (beneficiary.bene_type === 'corporate' || beneficiary.bene_type === 'company' ? 'Business' : beneficiary.bene_type || beneficiary.accounttype)
              : (beneficiary.type === 'corporate' || beneficiary.type === 'company' ? 'Business' : beneficiary.type || beneficiary.accounttype)}
          </span>
        </div>

      </div>
    </div>
  );

  if (!hideBackButton) {
    return (
      <div
        style={{
          minHeight: '100vh',
          padding: '32px 40px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          backgroundColor: '#ffffff',
          backgroundImage: `
            linear-gradient(
              180deg,
              rgba(248, 250, 252, 1) 0%,
              rgba(239, 246, 255, 0.3) 50%,
              rgba(238, 242, 255, 0.4) 100%
            )
          `,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }}
      >
        <div style={{ fontSize: 24, fontWeight: 700, color: '#394784', textAlign: 'center', marginBottom: 18 }}>
          Beneficiary Details
        </div>
        <div
          style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', marginBottom: 18, width: '640px', justifyContent: 'flex-start' }}
          onClick={() => navigate(-1, { state: { Nav_node } })}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ flexShrink: 0 }}>
            <path d="M19 12H5M5 12L11 18M5 12L11 6" stroke="#1D2338" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <span style={{ fontSize: 20, fontWeight: 700, color: '#1D2338' }}>Back</span>
        </div>
        {cardContent}
      </div>
    );
  }

  return cardContent;
}

const rowStyle = {
  display: 'flex',
  alignItems: 'center',
  width: '100%',
};

const labelStyle = {
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif",
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '100%',
  letterSpacing: '0px',
  color: '#676F7D',
  width: '200px',
  flexShrink: 0,
};

const valueStyle = {
  fontSize: '14px',
  fontWeight: 600,
  lineHeight: '100%',
  letterSpacing: '0px',
  color: '#1D2338',
  textAlign: 'left',
  wordBreak: 'break-word',
};

SendMoneyBeneficiaryDetail.propTypes = {
  beneficiary: PropTypes.shape({
    display_name: PropTypes.string,
    bank_account_number: PropTypes.string,
    iban: PropTypes.string,
    type: PropTypes.string,
    country: PropTypes.string,
    avatar: PropTypes.string,
    currency: PropTypes.string,
    payment_type: PropTypes.string,
    address: PropTypes.string,
    code: PropTypes.string,
    bene_type: PropTypes.string,
    bank_type: PropTypes.string,
  }),
  hideBackButton: PropTypes.bool,
  hideDeleteButton: PropTypes.bool,
  fullWidth: PropTypes.bool,
  currency_type: PropTypes.any,
  SendMoneyFlowCurrency: PropTypes.any,
};

export default SendMoneyBeneficiaryDetail;